export const OptionActionName = {
  ViewDetails: 'viewDetails',
  Demo: 'Demo',
  Remove: 'Remove'
}
